import { createAction } from 'redux-actions';
import { createRequestActions } from '../../../utils';
import * as homePageFormTypes from './homePageFormTypes';

export const onLoadHomePageForm = createAction(homePageFormTypes.LOAD_HOMEPAGE_FORM);
export const fetchHomePageForm = createRequestActions(homePageFormTypes.FETCH_HOMEPAGE_FORM);
export const saveHomePageForm = createRequestActions(homePageFormTypes.SAVE_HOMEPAGE_FORM);
export const saveButtonClicked = createAction(homePageFormTypes.SAVE_BUTTON_CLIKED);
